<template>
  <div class="made-by-component">
    <span slot="footer">©{{getDateYearActual()}} - FábricaInfo</span>
  </div>
</template>

<script>
export default {
  name: 'made-by',
  methods:{
    getDateYearActual () {
      let dt = new Date()
      return dt.getFullYear()
    },
  }
}
</script>

<style lang="scss">
.made-by-component {
  padding-bottom: 20px;
  display: flex;
  color: white;
  justify-content: center;
  position: absolute;
  bottom: 0;
  width: 100%;
}
</style>
